import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { tempSetUser, check } from './modules/auth/userSlice';
import combinedReducer from './modules/index';
import CustomAlertProvider from './context/CustomAlertContext';

const store = configureStore({
    reducer: combinedReducer,
});

function loadUser() {
    try {
        const user = localStorage.getItem('user');
        if (!user) return;
        store.dispatch(tempSetUser(JSON.parse(user)));
        store.dispatch(check());
    } catch (error) {
        console.error('localStorage is not working');
    }
}
loadUser();

const rootNode = document.getElementById('root');
ReactDOM.createRoot(rootNode).render(
    <Provider store={store}>
        <BrowserRouter basename="/quantity-estimation">
            <HelmetProvider>
                <CustomAlertProvider>
                    <App />
                </CustomAlertProvider>
            </HelmetProvider>
        </BrowserRouter>
    </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
